import styled from '@emotion/styled';
import { Button, TableBody, TableCell, TableContainer, TableFooter } from '@mui/material';
import Theme from 'App.theme';

export const ActionBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const UpdateAllButton = styled(Button)`
  margin-left: 20px;
  margin-bottom: 20px;
`;

export const SearchForm = styled.div`
  padding-bottom: 20px;
`;

export const Table = styled.div`
  border: 1px solid ${Theme.greys.GREY1};
  border-radius: 0.5rem;
  overflow: hidden;
`;

export const Container = styled(TableContainer)`
  display: flex;
  min-height: 300px;
  align-items: center;
  justify-content: center;
`;

export const TableBodyStyled = styled(TableBody)`
  padding: '20px';
`;

export const HeadTableCell = styled(TableCell)`
  background-color: ${Theme.greys.GREY1};
`;

export const Footer = styled(TableFooter)`
  display: table;
  width: 100%;
  border-top: 1px solid ${Theme.greys.GREY1};
`;
